exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tutorials{color:red}.menu-name-tutorial{position:absolute;left:17.7vw;font-style:normal;font-size:1.72vw;line-height:1;top:6.65vh}.menu-name-tutorial span{margin-right:3px}.menu-name-tutorial .myAccount-grey{color:#f1f1f1}.tutorials-landingbg{margin:3.63vh 3.2vw 0 6.5vw;min-height:30.86vh;overflow:hidden;padding-top:5vh}.tutorials-landingbg .tf-content-left{float:left;width:37vw}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tutorials/tutorials.scss
// module id = 148
// module chunks = 0